/**
 * Traveling Salesman (192): pending cheaper-hand overlays for viewer.
 */

const TRAVELING_SALESMAN_CHEAPER_HAND_SOURCE = 'traveling_salesman_192';

function consumePendingTravelingSalesmanCheaperHandAnimations(gameStateFragment, viewerUserId) {
  if (!gameStateFragment?.pendingTravelingSalesmanCheaperHandAnimations?.length) {
    return [];
  }
  if (viewerUserId == null) {
    throw new Error('consumePendingTravelingSalesmanCheaperHandAnimations: viewerUserId is required');
  }

  const pending = [...gameStateFragment.pendingTravelingSalesmanCheaperHandAnimations];
  delete gameStateFragment.pendingTravelingSalesmanCheaperHandAnimations;

  return pending
    .filter((anim) => String(anim.targetPlayerId) === String(viewerUserId))
    .map((anim) => {
      if (!anim.animationKey) {
        throw new Error('consumePendingTravelingSalesmanCheaperHandAnimations: animationKey is required');
      }
      return {
        key: anim.animationKey,
        source: anim.source || TRAVELING_SALESMAN_CHEAPER_HAND_SOURCE,
        durationMs: anim.durationMs,
      };
    });
}

module.exports = {
  consumePendingTravelingSalesmanCheaperHandAnimations,
};
